import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import rentIt from "@core/assets/icons/rent-it.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";
import { getEmbeddedSoftwarePath } from "@core/schema/paths/getEmbeddedSoftwarePath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";
import { getWebsitesPath } from "@core/schema/paths/getWebsitesPath.js";

export function getDevelopmentServices(tenant: Tenant): ServiceCardItem<true>[] {
	return [
		{
			title: "Webové aplikace",
			iconName: brackets,
			href: getWebAppsPath(tenant),
			show: true,
		},
		{
			title: "Mobilní aplikace",
			iconName: rentIt,
			href: "#",
			show: false,
		},
		{
			title: "Vývoj software",
			iconName: rentIt,
			href: "#", // TODO
			show: false,
		},
		{
			title: "Vývoj a tvorba webů",
			iconName: rentIt,
			href: getWebsitesPath(tenant),
			show: true,
		},
		{
			title: "Vývoj cloudových řešení",
			iconName: rentIt,
			href: getCloudSolutionsPath(tenant),
			show: true,
		},
		{
			title: "Vývoj embedded systémů",
			iconName: rentIt,
			href: getEmbeddedSoftwarePath(tenant),
			show: false,
		},
	];
}
